import type { FaireProductEntity } from "../../entity_types/product";

export const p_3xqg8gws5t: FaireProductEntity = {
  token: "p_3xqg8gws5t",
  type: "product",
  name: "LM-BN-1005 LULU MAC PATCH BEANIE NAVY",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/6bc27c8682796c00294484aa6e705688c9e3773de682bd13b97cf7a347dc1b85.jpeg",
  galleryImageUrls: [],
  priceDollars: 10,
  description: "Whether it’s for function or style, hair clips are a fun accessory for everyday use. Check out our variety of colors and sizes! \n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:57.381Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
